<div *ngIf="loading" class="loading-container">
	<p>{{ vps.isMobile ? 'Lade Punkte...' : 'Lade Punkte und generiere PDF-Vorschau...' }}</p>
</div>

<div *ngIf="!loading && bps.length === 0" class="no-points">
	<p>{{ ladeFehler || 'Keine Punkte zum Drucken ausgewählt.' }}</p>
	<button class="btn btn-primary" (click)="onClose()">Zurück zur Karte</button>
</div>

<div *ngIf="!loading && bps.length > 0" class="pdf-view-container">
	<div class="print-controls no-print">
		<span>
			<ng-container *ngIf="!isFiltered">{{ bps.length }} Punkt(e)</ng-container>
			<ng-container *ngIf="isFiltered">{{ effectiveCount }} von {{ bps.length }} Punkt(en)</ng-container>
		</span>

		<label class="ctrl-group">
			<input type="checkbox" class="form-check-input"
				[ngModel]="nurLangprotokoll"
				(ngModelChange)="onFilterToggle($event)"
				[disabled]="pdfExporting">
			<span title="Nur Punkte mit Langprotokoll exportieren — Kurzprotokoll-Punkte werden ausgeblendet">Nur Langprotokolle</span>
		</label>

		<label class="ctrl-group">
			<input type="checkbox" class="form-check-input"
				[ngModel]="mitProfilbild"
				(ngModelChange)="onProfilbildToggle($event)"
				[disabled]="pdfExporting">
			<span title="Hängt an jedes Protokoll eine Seite mit dem Profilbild (wie im Reiter „Profilbild“) und einer kurzen Erläuterung an, wie das Bild entsteht">Profilbild anhängen</span>
		</label>

		<div class="ctrl-group sort-group">
			<span>Sortierung</span>
			<div class="sort-keys">
				<div class="sort-key" *ngFor="let key of sortKeys; let i = index; trackBy: trackByIndex">
					<select class="form-select form-select-sm"
						title="Sortierkriterium"
						[ngModel]="key"
						(ngModelChange)="onSortKeyChange(i, $event)"
						[disabled]="pdfExporting">
						<option *ngFor="let opt of availableForSlot(i)" [value]="opt.key">{{ opt.label }}</option>
					</select>
					<button type="button" class="btn btn-sm btn-outline-secondary"
						*ngIf="sortKeys.length > 1"
						(click)="onRemoveSortKey(i)"
						[disabled]="pdfExporting"
						title="Kriterium entfernen">
						<i class="bi bi-x"></i>
					</button>
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary add-sort"
					*ngIf="canAddSortKey"
					(click)="onAddSortKey()"
					[disabled]="pdfExporting"
					title="Weiteres Sortierkriterium">
					<i class="bi bi-plus"></i>
				</button>
			</div>
		</div>

		<label class="ctrl-group">
			<span>Pro PDF</span>
			<input type="number" min="0" step="1" class="form-control form-control-sm chunk-input"
				[ngModel]="chunkSize"
				(ngModelChange)="onChunkSizeChange($event)"
				[disabled]="pdfExporting"
				title="0 = alle Punkte in eine Datei">
			<span class="hint" *ngIf="chunkSize > 0 && bps.length > chunkSize">
				= {{ chunkCount }} Dateien
			</span>
		</label>

		<button type="button" class="btn btn-primary" (click)="onSavePdf()" [disabled]="pdfExporting">
			<i class="bi" [ngClass]="pdfExporting ? 'bi-hourglass-split' : 'bi-file-pdf'"></i>
			{{ pdfExporting ? 'Exportiere...' : (hasMultipleChunks ? 'Als PDFs speichern' : 'Als PDF speichern') }}
		</button>
	</div>

	<div class="preview-hint no-print" *ngIf="hasMultipleChunks">
		<i class="bi bi-info-circle"></i>
		Vorschau zeigt nur die ersten {{ previewCount }} Punkte – beim Speichern werden alle {{ effectiveCount }} Punkte in {{ chunkCount }} Dateien aufgeteilt.
	</div>

	<!-- PDF-Vorschau nur auf Desktop (funktioniert nicht auf Android) -->
	<ng-container *ngIf="!vps.isMobile">
		<div class="pdf-preview-container" *ngIf="pdfPreviewUrl">
			<object [data]="pdfPreviewUrl" type="application/pdf" class="pdf-preview">
				<div class="pdf-fallback">
					<p>Vorschau auf mobilen Geräten nicht verfügbar.</p>
				</div>
			</object>
		</div>
		<div class="pdf-loading" *ngIf="!pdfPreviewUrl">
			<p>Generiere PDF-Vorschau...</p>
		</div>
	</ng-container>

	<!-- Mobil: Hinweis statt Vorschau -->
	<div class="mobile-hint" *ngIf="vps.isMobile">
		<p>Vorschau auf mobilen Geräten nicht verfügbar.</p>
	</div>
</div>
